// Extra i18n keys for the high-end upgrade: Live-Schaufenster, Marktplatz, CTAs.
// Merged into the main translations by LanguageContext.
export const extra = {
  de: {
    cta2: { reserve: "Im Laden reservieren", online: "Online entdecken", ricardo: "Unsere Auktionen auf Ricardo", tutti: "Aktuelle Inserate auf Tutti.ch" },
    fresh: {
      eyebrow: "Kuratierte Auswahl",
      title: "Heute frisch in der Wunderkammer",
      body: "Grüezi und herzlich willkommen. Diese Einzelstücke haben soeben ihren Platz in unserer Schatzkammer gefunden – ausgewählt für Menschen mit Sinn für das Besondere.",
      fomo: "Gleichzeitig online und im Laden verfügbar – ein echtes Einzelstück.",
    },
    market: {
      eyebrow: "Schweizer Marktplätze",
      title: "Finden Sie uns auf Ricardo und Tutti",
      body: "Unsere Schätze sind auch auf den führenden Schweizer Plattformen zu entdecken – sorgfältig fotografiert und beschrieben.",
    },
    footerGroup: "Ein Unternehmen der Mara Services Gruppe – Ihr Partner in Basel.",
    servicesMarket: "Was einen Wert hat, vermarkten wir erfolgreich über Ricardo und Tutti – transparent und zu fairen Bedingungen.",
    request: {
      eyebrow: "Terminanfrage",
      title: "Ihren Termin zur Räumung vereinbaren",
      subtitle: "Grüezi! Schildern Sie uns Ihr Anliegen – wir melden uns zeitnah mit einem unverbindlichen Vorschlag.",
      name: "Name", phone: "Telefon", email: "E-Mail",
      address: "Adresse der Liegenschaft", zip: "PLZ", city: "Ort",
      service: "Gewünschte Dienstleistung",
      serviceOptions: ["Räumung", "Entsorgung", "Ankauf", "Beratung vor Ort"],
      property: "Art des Objekts",
      propertyOptions: ["Wohnung", "Einfamilienhaus", "Keller / Estrich", "Geschäftsräume", "Nachlass"],
      date: "Wunschtermin", size: "Grösse / Zimmeranzahl",
      details: "Weitere Angaben zum Objekt",
      submit: "Anfrage senden",
      success: "Vielen Dank! Ihre Räumungsanfrage ist eingegangen – wir melden uns in Kürze bei Ihnen.",
      choose: "Bitte wählen",
    },
    platforms: { title: "Unser Sortiment", same: "Dasselbe Sortiment – nur die Plattform ändert sich.", website: "Unser Sortiment auf unserer Website", tutti: "Unser Sortiment auf Tutti", ricardo: "Unser Sortiment auf Ricardo", anibis: "Unser Sortiment auf Anibis", websiteDesc: "Kuratierte Schätze direkt hier ansehen", extDesc: "Dieselben Objekte auf der Plattform" },
    reviews: { title: "Vertrauen & Bewertungen", subtitle: "Sehen Sie selbst, was andere über uns sagen – oder entdecken Sie unser Sortiment auf den Schweizer Plattformen.", google: "Google-Bewertungen" },
    opening: { badge: "Neueröffnung · 15. Juli 2026", title: "Die Wunderkammer öffnet ihre Türen!", body: "Am 15. Juli 2026 ist es soweit: Die Wunderkammer Basel lädt Sie ein, eine Welt voller einzigartiger Fundstücke, erlesenem Kaffee und besonderer Geschichten zu entdecken. Seien Sie dabei, wenn wir unsere Türen öffnen!", cta: "Jetzt entdecken", close: "Schliessen" },
  },
  en: {
    cta2: { reserve: "Reserve in store", online: "Discover online", ricardo: "Our auctions on Ricardo", tutti: "Current listings on Tutti.ch" },
    fresh: {
      eyebrow: "Curated selection",
      title: "Fresh today in the chamber of wonders",
      body: "A warm welcome. These unique pieces have just found their place in our treasure chamber – chosen for those with a sense for the exceptional.",
      fomo: "Available online and in store at the same time – a true one-of-a-kind.",
    },
    market: {
      eyebrow: "Swiss marketplaces",
      title: "Find us on Ricardo and Tutti",
      body: "Our treasures can also be discovered on Switzerland's leading platforms – carefully photographed and described.",
    },
    footerGroup: "A company of the Mara Services Group – your partner in Basel.",
    servicesMarket: "Whatever holds value, we successfully market via Ricardo and Tutti – transparently and on fair terms.",
    request: {
      eyebrow: "Appointment request",
      title: "Book your clearance appointment",
      subtitle: "Welcome! Tell us about your project – we will get back to you shortly with a non-binding proposal.",
      name: "Name", phone: "Phone", email: "Email",
      address: "Property address", zip: "Postal code", city: "City",
      service: "Requested service",
      serviceOptions: ["Clearance", "Disposal", "Purchase", "On-site consultation"],
      property: "Type of property",
      propertyOptions: ["Apartment", "House", "Cellar / Attic", "Business premises", "Estate"],
      date: "Preferred date", size: "Size / number of rooms",
      details: "Further details about the property",
      submit: "Send request",
      success: "Thank you! Your clearance request has been received – we will contact you shortly.",
      choose: "Please select",
    },
    platforms: { title: "Our assortment", same: "The same assortment – only the platform changes.", website: "Our assortment on our website", tutti: "Our assortment on Tutti", ricardo: "Our assortment on Ricardo", anibis: "Our assortment on Anibis", websiteDesc: "Browse the curated treasures right here", extDesc: "The same objects on the platform" },
    reviews: { title: "Trust & reviews", subtitle: "See for yourself what others say – or discover our assortment on the Swiss platforms.", google: "Google reviews" },
    opening: { badge: "Grand opening · 15 July 2026", title: "The Wunderkammer opens its doors!", body: "On 15 July 2026 the time has come: Wunderkammer Basel invites you to discover a world full of unique finds, exquisite coffee and special stories. Be there when we open our doors!", cta: "Discover now", close: "Close" },
  },
  it: {
    cta2: { reserve: "Riserva in negozio", online: "Scopri online", ricardo: "Le nostre aste su Ricardo", tutti: "Annunci attuali su Tutti.ch" },
    fresh: {
      eyebrow: "Selezione curata",
      title: "Freschi oggi nella camera delle meraviglie",
      body: "Un caloroso benvenuto. Questi pezzi unici hanno appena trovato posto nella nostra camera dei tesori – scelti per chi ha il senso dell'eccezionale.",
      fomo: "Disponibile online e in negozio allo stesso tempo – un vero pezzo unico.",
    },
    market: {
      eyebrow: "Mercati svizzeri",
      title: "Trovateci su Ricardo e Tutti",
      body: "I nostri tesori si scoprono anche sulle principali piattaforme svizzere – fotografati e descritti con cura.",
    },
    footerGroup: "Un'azienda del Gruppo Mara Services – il vostro partner a Basilea.",
    servicesMarket: "Ciò che ha valore lo commercializziamo con successo tramite Ricardo e Tutti – in modo trasparente e a condizioni eque.",
    request: {
      eyebrow: "Richiesta di appuntamento",
      title: "Prenota il tuo appuntamento di sgombero",
      subtitle: "Benvenuti! Descriveteci la vostra esigenza – vi risponderemo a breve con una proposta senza impegno.",
      name: "Nome", phone: "Telefono", email: "Email",
      address: "Indirizzo dell'immobile", zip: "CAP", city: "Località",
      service: "Servizio richiesto",
      serviceOptions: ["Sgombero", "Smaltimento", "Acquisto", "Consulenza in loco"],
      property: "Tipo di immobile",
      propertyOptions: ["Appartamento", "Casa", "Cantina / Solaio", "Locali commerciali", "Eredità"],
      date: "Data desiderata", size: "Dimensione / numero di stanze",
      details: "Ulteriori dettagli sull'immobile",
      submit: "Invia richiesta",
      success: "Grazie! La vostra richiesta di sgombero è stata ricevuta – vi contatteremo a breve.",
      choose: "Selezionare",
    },
    platforms: { title: "Il nostro assortimento", same: "Lo stesso assortimento – cambia solo la piattaforma.", website: "Il nostro assortimento sul nostro sito", tutti: "Il nostro assortimento su Tutti", ricardo: "Il nostro assortimento su Ricardo", anibis: "Il nostro assortimento su Anibis", websiteDesc: "Scopri qui i tesori curati", extDesc: "Gli stessi oggetti sulla piattaforma" },
    reviews: { title: "Fiducia e recensioni", subtitle: "Scoprite cosa dicono gli altri – o il nostro assortimento sulle piattaforme svizzere.", google: "Recensioni Google" },
    opening: { badge: "Inaugurazione · 15 luglio 2026", title: "La Wunderkammer apre le sue porte!", body: "Il 15 luglio 2026 è il momento: la Wunderkammer Basel vi invita a scoprire un mondo di pezzi unici, caffè pregiato e storie speciali. Ci sarete quando apriremo le nostre porte?", cta: "Scopri ora", close: "Chiudi" },
  },
  fr: {
    cta2: { reserve: "Réserver en magasin", online: "Découvrir en ligne", ricardo: "Nos enchères sur Ricardo", tutti: "Annonces actuelles sur Tutti.ch" },
    fresh: {
      eyebrow: "Sélection curatée",
      title: "Frais aujourd'hui dans le cabinet de curiosités",
      body: "Bienvenue à vous. Ces pièces uniques viennent de trouver leur place dans notre chambre aux trésors – choisies pour celles et ceux qui ont le sens de l'exceptionnel.",
      fomo: "Disponible en ligne et en magasin en même temps – une véritable pièce unique.",
    },
    market: {
      eyebrow: "Marchés suisses",
      title: "Retrouvez-nous sur Ricardo et Tutti",
      body: "Nos trésors se découvrent aussi sur les principales plateformes suisses – photographiés et décrits avec soin.",
    },
    footerGroup: "Une entreprise du Groupe Mara Services – votre partenaire à Bâle.",
    servicesMarket: "Ce qui a de la valeur, nous le commercialisons avec succès via Ricardo et Tutti – en toute transparence et à des conditions équitables.",
    request: {
      eyebrow: "Demande de rendez-vous",
      title: "Réservez votre rendez-vous de débarras",
      subtitle: "Bienvenue ! Décrivez-nous votre projet – nous vous répondrons rapidement avec une proposition sans engagement.",
      name: "Nom", phone: "Téléphone", email: "E-mail",
      address: "Adresse du bien", zip: "Code postal", city: "Ville",
      service: "Service souhaité",
      serviceOptions: ["Débarras", "Élimination", "Achat", "Conseil sur place"],
      property: "Type de bien",
      propertyOptions: ["Appartement", "Maison", "Cave / Grenier", "Locaux commerciaux", "Succession"],
      date: "Date souhaitée", size: "Taille / nombre de pièces",
      details: "Détails supplémentaires sur le bien",
      submit: "Envoyer la demande",
      success: "Merci ! Votre demande de débarras a bien été reçue – nous vous contacterons prochainement.",
      choose: "Veuillez choisir",
    },
    platforms: { title: "Notre assortiment", same: "Le même assortiment – seule la plateforme change.", website: "Notre assortiment sur notre site", tutti: "Notre assortiment sur Tutti", ricardo: "Notre assortiment sur Ricardo", anibis: "Notre assortiment sur Anibis", websiteDesc: "Découvrez les trésors curatés ici", extDesc: "Les mêmes objets sur la plateforme" },
    reviews: { title: "Confiance et avis", subtitle: "Découvrez ce que disent les autres – ou notre assortiment sur les plateformes suisses.", google: "Avis Google" },
    opening: { badge: "Ouverture · 15 juillet 2026", title: "La Wunderkammer ouvre ses portes !", body: "Le 15 juillet 2026, le moment est venu : la Wunderkammer Basel vous invite à découvrir un monde de trouvailles uniques, de café raffiné et d'histoires particulières. Soyez présent lors de notre ouverture !", cta: "Découvrir", close: "Fermer" },
  },
  pt: {
    cta2: { reserve: "Reservar na loja", online: "Descobrir online", ricardo: "Os nossos leilões no Ricardo", tutti: "Anúncios atuais no Tutti.ch" },
    fresh: {
      eyebrow: "Seleção curada",
      title: "Fresco hoje na câmara das maravilhas",
      body: "Sejam bem-vindos. Estas peças únicas acabaram de encontrar o seu lugar na nossa câmara de tesouros – escolhidas para quem tem sentido para o excecional.",
      fomo: "Disponível online e na loja ao mesmo tempo – uma verdadeira peça única.",
    },
    market: {
      eyebrow: "Mercados suíços",
      title: "Encontre-nos no Ricardo e no Tutti",
      body: "Os nossos tesouros também podem ser descobertos nas principais plataformas suíças – cuidadosamente fotografados e descritos.",
    },
    footerGroup: "Uma empresa do Grupo Mara Services – o seu parceiro na Basileia.",
    servicesMarket: "O que tem valor, comercializamos com sucesso através do Ricardo e do Tutti – de forma transparente e em condições justas.",
    request: {
      eyebrow: "Pedido de marcação",
      title: "Marque a sua remoção",
      subtitle: "Bem-vindos! Descreva-nos o seu projeto – responderemos em breve com uma proposta sem compromisso.",
      name: "Nome", phone: "Telefone", email: "E-mail",
      address: "Morada do imóvel", zip: "Código postal", city: "Localidade",
      service: "Serviço pretendido",
      serviceOptions: ["Remoção", "Eliminação", "Compra", "Aconselhamento no local"],
      property: "Tipo de imóvel",
      propertyOptions: ["Apartamento", "Moradia", "Cave / Sótão", "Espaço comercial", "Herança"],
      date: "Data pretendida", size: "Tamanho / número de divisões",
      details: "Mais detalhes sobre o imóvel",
      submit: "Enviar pedido",
      success: "Obrigado! O seu pedido de remoção foi recebido – entraremos em contacto em breve.",
      choose: "Selecione",
    },
    platforms: { title: "O nosso sortido", same: "O mesmo sortido – só muda a plataforma.", website: "O nosso sortido no nosso site", tutti: "O nosso sortido no Tutti", ricardo: "O nosso sortido no Ricardo", anibis: "O nosso sortido no Anibis", websiteDesc: "Veja os tesouros curados aqui", extDesc: "Os mesmos objetos na plataforma" },
    reviews: { title: "Confiança e avaliações", subtitle: "Veja o que outros dizem – ou o nosso sortido nas plataformas suíças.", google: "Avaliações Google" },
    opening: { badge: "Inauguração · 15 de julho de 2026", title: "A Wunderkammer abre as suas portas!", body: "A 15 de julho de 2026 chega o momento: a Wunderkammer Basel convida-o a descobrir um mundo de achados únicos, café requintado e histórias especiais. Esteja presente quando abrirmos as nossas portas!", cta: "Descobrir agora", close: "Fechar" },
  },
};
